import React from 'react';

import { useOpenCompetencyDrawer } from 'components/Develop/helpers/useOpenCompetencyDrawer';
import styled from 'styled-components';
import { VerticallyAlignedFlexContainer } from 'styles/common';

import { MISCELLANEOUS_COMPETENCY_ID } from 'constants/ProjectConstants';
import { sendViewedShared } from 'constants/mixpanelHelper';
import theme from 'constants/theme';

import { Button } from 'uiToolkitV1/Button';

const OtherFeedback = ({ employeeId }) => {
  // const employeeId = useSelector(selectLoggedInEmployeeId);
  const { openCompetencyPanel } = useOpenCompetencyDrawer();

  const handleStrengthClickPage = (description = '') => {
    const tagTitle = 'Other Praises/Advices';
    sendViewedShared({
      eventProperties: {
        source: 'Profile',
      },
    });

    openCompetencyPanel({
      tagId: MISCELLANEOUS_COMPETENCY_ID,
      tagTitle,
      employeeId,
    });
  };
  return (
    <VerticallyAlignedFlexContainer>
      <ButtonColorWrapper>
        <Button variant="tertiary" onClick={handleStrengthClickPage}>
          View all other Praises/Advices
        </Button>
      </ButtonColorWrapper>
    </VerticallyAlignedFlexContainer>
  );
};

const ButtonColorWrapper = styled('div')`
  color: ${theme.palette.text.blue};
  margin-left: auto;
  p {
    color: ${theme.palette.text.blue} !important;
    font-weight: 400;
  }
`;

export default OtherFeedback;
